
<template>
    <div class="customervendor-container">
        <ThatsTable title="Customer Order" ref="table" :newBtn="false" :multipleSelection="checkSystemSupport" :endpoint="endpoint" @openModal="openWindow" @deleteYes="DispatchDelete" @openUpdateModal="OpenUpdateModal" :columns="columns"></ThatsTable>
        <CustomerOrderForm ref="dialogForm" @success="refreshTable" @delete="formDelete" :group="3"></CustomerOrderForm>
    </div>
</template>
<script>
import { mapGetters, mapMutations,mapActions } from 'vuex';
import CustomerOrderForm from './CustomerOrderForm'
import ThatsTable from '../../components/thats/Table'
export default {
    data(){
        return {
            endpoint : 'customer-order/data'
        }
    },
    components: {
        CustomerOrderForm,
        ThatsTable
    },

    methods: {
        ...mapActions('CustomerOrderModule',[ 'deleteRecord','getRecord']),
        ...mapMutations('CustomerOrderModule',[ 'setFormRecord', 'setFormStatusUpdate']),

        formDelete(record){
            const items = [];
            items.push(record.row);
            this.DispatchDelete(items);
        },
        DispatchDelete(items){
            var self = this;
            self.deleteRecord(items).then((response) => {
                self.$ThatsNotify.success({
                    message : `(${response.deleted}) record was successfully deleted.`
                })
               self.refreshTable();
            })
            // this.openWindow()
        },
        OpenUpdateModal(obj){
             let self = this
            const form  = {...obj.row,items : [],attachment : []}           
            self.setFormStatusUpdate()
            self.setFormRecord(form)
            self.getRecord(obj.row)
            self.openWindow()
        },
        openWindow(){
            this.$refs.dialogForm.openDialog()
        },
        closeWindow(){
            this.$refs.dialogForm.closeDialog()
        },
        refreshTable(){
            this.$refs.table.refreshTable()
        },
        
    },
    computed: {
        ...mapGetters('CustomerOrderModule',[ 'data', 'page', 'total', 'page', 'length', 'columns', 'Loading', ]),
        checkSystemSupport : function(){
            const systemSupport = this.$helpers.isSystemAdministrator();
            return systemSupport
        }
    },
}
</script>
<style scoped>
.container {
    position: relative;
    min-height: 340px;
  }
  .placement {
    position: absolute;
    right: 0;
  }
</style>